var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticStyle:{"transition":"width 1.25s"},attrs:{"id":_vm.id,"size":_vm.size,"disabled":_vm.disabled,"variant":_vm.status == 'success'
        ? 'success'
        : _vm.status == 'loading'
        ? 'warning'
        : _vm.status == 'error'
        ? 'danger'
        : 'primary'},on:{"click":_vm.buttonClicked}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('Transition',{attrs:{"name":"bounce"}},[(_vm.status != 'default')?_c('i',{class:_vm.status == 'success'
            ? 'fas fa-check ml-1'
            : _vm.status == 'loading'
            ? 'fas fa-spinner fa-spin ml-1'
            : 'fas fa-exclamation ml-1',staticStyle:{"font-size":"1.15em","width":"15px","--fa-animation-duration":"15s"}}):_vm._e()])],1),(_vm.status == 'error')?_c('b-popover',{attrs:{"show":"","target":_vm.id,"triggers":"hover","placement":"left","variant":"danger"}},[_c('div',{staticStyle:{"font-size":"1.2em"}},[_vm._v(" "+_vm._s(_vm.$t('errors.operationFailedTryAgain'))+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }